module.exports = __webpack_public_path__ + "static/logos/apple-logo--black-8e86fff8e8eef89586920b87298cb0ad.svg";